import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PdfSelectorComponent } from './pdf-selector/pdf-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { PdfCoreService } from './pdf-core.service';

@NgModule({
  declarations: [PdfSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [PdfCoreService],
  exports: [PdfSelectorComponent],
})
export class PdfCoreModule {}
